import { render, staticRenderFns } from "./ListBtn.vue?vue&type=template&id=563fa9e4"
import script from "./ListBtn.vue?vue&type=script&lang=js"
export * from "./ListBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports